import { TimelineMax, Linear, Power0, } from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

export default function() {
	(function ($) {

////
// Frontpage intro
////

//track mouse on hover
// 	var tooltips = document.querySelectorAll('.hp-services__headline a span');
//
// 	window.onmousemove = function (e) {
// 		var x = (e.clientX) + 'px',
// 			y = (e.clientY) + 'px';
// 		for (var i = 0; i < tooltips.length; i++) {
// 			tooltips[i].style.top = y;
// 			tooltips[i].style.left = x;
// 		}
// 	};

		function writeHandLeft() {
			$('.write__hand_first').each(function (i, obj) {
				var tl = new TimelineMax();
				tl.fromTo(".write__hand_first", {x: "-10%"}, {x: "0", stagger: 0.2, ease: Power0.easeOut},)
				ScrollTrigger.create({
					animation: tl,
					trigger: obj,
					start: "top bottom",
					end: "bottom top",
					scrub: 1,

				});
			});
		}

		function writeHandRight() {
			$('.write__hand_second').each(function (i, obj) {
				var tl = new TimelineMax();
				tl.fromTo(".write__hand_second", {x: "5%"}, {x: "0", stagger: 0.2, ease: Power0.easeOut},)
				ScrollTrigger.create({
					animation: tl,
					trigger: obj,
					start: "top bottom",
					end: "bottom top",
					scrub: 1,
				});
			});
		}


		function frontpage_ref_scroll() {
			$('.headline-slide').each(function () {
				var tl = new TimelineMax();
				tl.fromTo($(this).find(".headline-slide-text"), {x: "0%"}, {
					x: "80%",
					stagger: 0.2,
					ease: Power0.easeOut
				},)
				ScrollTrigger.create({
					animation: tl,
					trigger: $(this),
					start: "top bottom",
					end: "bottom top",
					scrub: 1,
				});
			});
		}


		function frontpage_ref_scroll_reverse() {
			$('.headline-slide').each(function () {
				var tl = new TimelineMax()
				tl.fromTo($(this).find(".headline-slide-text--reverse"), {x: "0%"}, {
					x: "-50%",
					stagger: 0.2,
					ease: Power0.easeOut
				},)
				ScrollTrigger.create({
					animation: tl,
					trigger: $(this),
					start: "top bottom",
					end: "bottom top",
					scrub: 1,
				});
			});
		}


		function writeHandFirst() {
			var tl = new TimelineMax()
			tl.fromTo('.write__hand_first', 1, {x: "-100%"}, {x: "0%", stagger: 1, ease: Power0.easeOut},)
		}


		function fadeInUp() {
			$(".fadeInUp ").each(function () {
				var tl = new TimelineMax().fromTo($(this), {opacity: "0", y: "10%"}, {
					opacity: 1,
					y: "0%",
					duration: .8
				})
				ScrollTrigger.create({
					animation: tl,
					trigger: $(this),
					start: "15% bottom",
					// markers: true,
				});
			});
		}

		function text_headline_splited() {
			var sections = gsap.utils.toArray(".headline__animated").forEach(function (elem) {
				var blocks = elem.querySelectorAll(".headline__animation");
				var tl = gsap.timeline({
					scrollTrigger: {
						trigger: blocks,
						start: "top 100%",
						markers: false,
						reverse: false,
					},
				})
				tl.fromTo(blocks, 1, {opacity: 0, y: "120%"}, {
					opacity: 1,
					y: "0%",
					stagger: 0.3,
					ease: Power3.easeOut
				}, "-=1.3")
			})
		}

		function text_headline() {
			$(".text_animation").each(function () {
				var blocks = $(this);
				var tl = gsap.timeline({
					scrollTrigger: {
						trigger: blocks,
						start: "top 100%",
						markers: false,
						reverse: false,
					},
				})
				tl.fromTo(blocks, 1, {opacity: 0, y: "120%"}, {
					opacity: 1,
					y: "0%",
					stagger: 0.3,
					ease: Power3.easeOut
				}, "-=1.3")
			})
		}

		function mainHeadlineFadeInUp() {
			var tl = new TimelineMax()
			tl.fromTo('.intro__heading', 2, {y: "100px"}, {y: "0px", stagger: 1, delay: 1, ease: Power3.easeOut},)
		}

		function fadeInUpRef() {
			$(".ref-archive__filter .btn ").click(function () {
				$(".fadeInUpRef .references--image ").each(function () {
					var tl = new TimelineMax()
					tl.fromTo($(this), {opacity: "0", y: "10%"}, {opacity: 1, y: "0%", duration: .2, delay: .4})
					$grid.on('arrangeComplete', function () {
						tl.repeat();
					})
				});
			});
		}


		function hp_references_parallax() {
			$(".references__reference").each(function () {
				var tl = new TimelineMax();
				var topScroll = 150;
				var screenWidth = window.innerWidth;
				if (screenWidth < 991 && screenWidth > 400) {
					topScroll = 100;
				} else if (window.innerWidth <= 400) {
					topScroll = 50;
				}
				// var topScroll = window.innerWidth < 991 ? 100 : 150;
				console.log(topScroll);
				var child = $(this).find(".reference--parallax img");
				tl.fromTo(child, 1, {y: "-" + topScroll}, {y: topScroll, ease: Linear.easeNone},);
				ScrollTrigger.create({
					animation: tl,
					trigger: $(this),
					start: "top bottom",
					end: "bottom top",
					scrub: true,
				});
				$grid.on('arrangeComplete', function () {
					ScrollTrigger.refresh();
				})
			});
		}

		function buble_parallax_down() {
			var tl = new TimelineMax();
			tl.fromTo(".hp-intro__buble-first", {y: "0%"}, {y: "-60%",},);
			ScrollTrigger.create({
				animation: tl,
				trigger: ".hp-intro",
				start: "top top",
				end: "140% top",
				scrub: true,
			});
		}

		function buble_parallax_up() {
			var tl = new TimelineMax();
			tl.fromTo(".hp-intro__buble-second", {y: "0%"}, {y: "-100%"},);
			ScrollTrigger.create({
				animation: tl,
				trigger: ".hp-intro",
				start: "top top",
				end: "140% top",
				scrub: true,
			});
		}

		function mainHeadlineFadeOut() {
			var that = $(this);
			var tl = new TimelineMax();
			tl.fromTo(".intro__heading", 1, {opacity: "1"}, {opacity: "0",});
			ScrollTrigger.create({
				animation: tl,
				trigger: ".hp-intro",
				start: "top top",
				end: "90% top",
				scrub: true,
				onEnterBack: () => $(".intro__heading").removeClass("intro__heading--scrolled"),
				onLeave: () => $(".intro__heading").addClass("intro__heading--scrolled"),
			});
		}

		function mainHeadlineFadeInUp() {
			var tl = new TimelineMax()
			tl.fromTo('.intro__heading', 2, {y: "100px"}, {y: "0px", stagger: 1, delay: 1, ease: Power3.easeOut},)
		}

		function mainDuchFadeInUp() {
			var tl = new TimelineMax()
			tl.fromTo('.hp-intro__duch img', 1.3, {opacity: 0, y: "50px"}, {
				opacity: 1,
				y: "0px",
				stagger: 1,
				delay: 2,
				ease: Power3.easeOut
			},)
		}

		function bublesFadeInUp() {
			var tl = new TimelineMax()
			tl.fromTo('.hp-intro__buble-first img', 1.3, {opacity: 0, y: "-70px"}, {
				opacity: 1,
				y: "0px",
				stagger: 1,
				delay: 2.5,
				ease: Power3.easeOut
			},)
		}

		function bublesFadeInDown() {
			var tl = new TimelineMax()
			tl.fromTo('.hp-intro__buble-second img', 1.3, {opacity: 0, y: "70px", rotation: "30deg"}, {
				opacity: 1,
				y: "0px",
				rotation: "0deg",
				stagger: 1,
				delay: 2.5,
				ease: Power3.easeOut
			},)
		}

		function mainAnimationEndClass() {
			$("body").addClass("animating");
		}


		function animationCompleted() {
			$("body").removeClass("animating");
		}

// function animationStarted(start) {
// 	$(start).addClass("animationStarted");
// 	// console.log($(this));
// }

		function mainHeadline() {
			$(".intro__heading-line").each(function (index) {
				delayIndex = "0." + index;
				customDelay = "0.2" * index;
				var that = $(this);
				console.log(customDelay);
				var blocks = $(this);
				var tl = gsap.timeline({
					scrollTrigger: {
						trigger: blocks,
						start: "top 100%",
						markers: false,
						reverse: false,
					},

				})
				tl.fromTo(blocks, 1, {opacity: 0}, {
					opacity: 1,
					stagger: 0.3,
					delay: customDelay,
					ease: Power3.easeOut,
					onStart: function () {
						$(that).addClass('animationStarted')
					},
					onComplete: animationCompleted
				}, "+=1")
			})
		}


		window.onload = function () {

			if ($('.headline-slide-text').length) {
				frontpage_ref_scroll_reverse();
				frontpage_ref_scroll();
			}
			if ($('.hp-intro').length) {
				mainHeadline();
				mainAnimationEndClass();
			}
			if ($('.intro__heading').length) {
				mainHeadlineFadeInUp();
				mainDuchFadeInUp();
				mainHeadlineFadeOut();
			}

			if ($('.references').length) {
				hp_references_parallax();
			}
			if ($('.fadeInUp').length) {
				fadeInUp();
			}
			if ($('.fadeInUpRef').length) {

				fadeInUpRef();
			}
			if ($('.headline__animated').length) {
				text_headline_splited();
			}
			if ($('.text_animation').length) {
				text_headline();
			}
			if ($('.write__hand_first').length) {
				writeHandLeft();
			}
			if ($('.write__hand_second').length) {
				writeHandRight();
			}
			// if($('.write__hand_first').length){
			// 	writeHandFirst();
			// }
			if ($('.hp-intro__buble').length) {
				buble_parallax_up();
				buble_parallax_down();
				bublesFadeInUp();
				bublesFadeInDown();
			}

		};


	})(jQuery);
}